import React, { useState, useEffect } from "react";
import {
  getProvider,
  updateProviderRequest,
  getOrganisation,
  getMerchantDailyTransactions,
} from "../../../config/LiveApi";
import { CiEdit } from "react-icons/ci";
import Modal from "./Modal";
import { toast } from "react-toastify";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { useSelector } from "react-redux";
import { FaFilter } from "react-icons/fa";
import ProviderModal from "./ProviderModal";
import { DateRangePicker } from "react-date-range";
import { FaCalendar } from "react-icons/fa6";
import Spinner from "../../Spin/Spinner";

const GetProvider = () => {
  const FIXED_DATE = "2025-01-01";
  const [providerTableData, setProviderTableData] = useState([]);
  const [currentProvider, setCurrentProvider] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [orgOptions, setOrgOptions] = useState([]);
  const [orgName, setOrgName] = useState(false);
  const [selectedOrgName, setSelectedOrgName] = useState(null);
  const [showType, setShowType] = useState(false);
  const [typeFilter, setTypeFilter] = useState("");
  const [selectedProviderId, setSelectedProviderId] = useState(null);
  const [selectedProviderName, setSelectedProviderName] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPicker, setShowPicker] = useState(false);

  const [initialStartDate, setInitialStartDate] = useState(new Date());
  const [initialEndDate, setInitialEndDate] = useState(new Date());

  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [showActive, setShowActive] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });

  let token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  const customDate = () => {
    setShowPicker(!showPicker);
  };

  useEffect(() => {
    const currentDate = new Date();
    const previousDate = new Date();
    previousDate.setDate(previousDate.getDate() - 1);

    previousDate.setUTCHours(18, 30, 0, 0);
    currentDate.setUTCHours(18, 29, 59, 999);

    setInitialStartDate(previousDate);
    setInitialEndDate(currentDate);

    setSelectedStartDate(previousDate);
    setSelectedEndDate(currentDate);
  }, []);

  const handleSelect = (ranges) => {
    const newStartDate = new Date(ranges.selection.startDate);
    const newEndDate = new Date(ranges.selection.endDate);

    newStartDate.setUTCHours(18, 30, 0, 0);
    newEndDate.setUTCDate(newEndDate.getUTCDate() + 1);
    newEndDate.setUTCHours(18, 29, 59, 999);

    setState({
      selection: {
        startDate: newStartDate,
        endDate: newEndDate,
        key: "selection",
      },
    });

    setSelectedStartDate(newStartDate);
    setSelectedEndDate(newEndDate);
  };

  const handleApply = () => {
    setShowPicker(false);
    fetchProviders();
  };

  const handleClear = (e) => {
    e.preventDefault();
    setShowPicker(false);
    fetchProviders();
  };

  const handleProviderClick = async (providerId, name) => {
    setSelectedProviderId(providerId);
    setSelectedProviderName(name);
    setTransactionData([]); // Clear previous data
    setShowModal(true); // Show modal immediately
    setIsLoading(true);

    let startDate = new Date(selectedStartDate);
    let endDate = new Date(selectedEndDate);
    startDate.setUTCHours(18, 30, 0, 0);
    endDate.setUTCHours(18, 29, 59, 999);

    try {
      const data = await getMerchantDailyTransactions(
        providerId,
        startDate.toISOString(),
        endDate.toISOString()
      );
      setTransactionData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching transaction data", error);
    } finally {
      setIsLoading(false); // Hide spinner after fetching
    }
  };

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
        toast.error("Unable to fetch organisations.");
      }
    };

    fetchOrganisations();
  }, [token]);

  const fetchProviders = async () => {
    setIsLoading(true);
    const response = await getProvider(token);
    setProviderTableData(response.data.providers || []);
    setIsLoading(false);
  };

  const updateProvider = (item) => {
    let min = "";
    let max = "";

    if (item.validLength && item.validLength.includes("-")) {
      const parts = item.validLength.split("-");
      min = parts[0] || "";
      max = parts[1] || "";
    }

    setCurrentProvider({
      ...item,
      minLength: min,
      maxLength: max,
    });

    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setCurrentProvider(null);
  };

  const handleUpdateSubmit = async (event) => {
    event.preventDefault();

    if (!currentProvider) return;

    const type = currentProvider.type;

    // Payin limit check
    if (type === "payin" || type === "both") {
      const min = Number(currentProvider.payinMinPerTxn);
      const max = Number(currentProvider.payinMaxPerTxn);
      if (min && max && max <= min) {
        toast.error("Maximum Payin must be greater than Minimum Payin.");
        return;
      }
    }

    // Payout limit check
    if (type === "payout" || type === "both") {
      const min = Number(currentProvider.payoutMinPerTxn);
      const max = Number(currentProvider.payoutMaxPerTxn);

      if (min && max && max <= min) {
        toast.error("Maximum Payout must be greater than Minimum Payout.");
        return;
      }
    }

    // Time validation
    // if (currentProvider.startTime && currentProvider.endTime) {
    //   // If startTime / endTime come as ISO strings, extract time
    //   const start = currentProvider.startTime.includes("T")
    //     ? currentProvider.startTime.split("T")[1].slice(0, 5)
    //     : currentProvider.startTime;

    //   const end = currentProvider.endTime.includes("T")
    //     ? currentProvider.endTime.split("T")[1].slice(0, 5)
    //     : currentProvider.endTime;

    //   const [sh, sm] = start.split(":").map(Number);
    //   const [eh, em] = end.split(":").map(Number);

    //   const startMinutes = sh * 60 + sm;
    //   const endMinutes = eh * 60 + em;

    //   if (endMinutes <= startMinutes) {
    //     toast.error("End time must be greater than Start time.");
    //     return;
    //   }
    // }

    try {
      await updateProviderRequest(token, currentProvider.id, currentProvider);

      setProviderTableData((prevProviderData) =>
        prevProviderData.map((provider) =>
          provider.id === currentProvider.id
            ? { ...provider, ...currentProvider }
            : provider
        )
      );

      toast.success("User updated successfully.");
      handleModalClose();
    } catch (err) {
      console.error(err.message);
      toast.error("Failed to update provider.");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    let parsedValue = value;

    if (name === "isActive") {
      parsedValue = JSON.parse(value); // Convert "true"/"false" string to boolean
    } else if (["runningWalletAmount", "dailyPayinAmount"].includes(name)) {
      parsedValue = parseFloat(value) || 0; // Convert only these fields to float
    } else if (["minLength", "maxLength"].includes(name)) {
      parsedValue = value === "" ? "" : parseInt(value, 10);

      // handle min/max + auto-generate validLength
      return setCurrentProvider((prev) => {
        const updated = { ...prev, [name]: parsedValue };

        // both min & max present → create "Min-Max"
        if (updated.minLength !== "" && updated.maxLength !== "") {
          updated.validLength = `${updated.minLength}-${updated.maxLength}`;
        } else {
          updated.validLength = "";
        }

        return updated;
      });
    } else if (["startTime", "endTime"].includes(name)) {
      parsedValue = `${FIXED_DATE}T${value}`;
    }

    setCurrentProvider((prev) => ({ ...prev, [name]: parsedValue }));
  };

  useEffect(() => {
    fetchProviders();
  }, []);
  return (
    <>
      <div>
        <div className="dash-head">
          <h1 style={{ marginBottom: "20px" }}>List of Providers</h1>
          <div className="pay-in-out-div">
            <p onClick={() => customDate()}>Select Date : </p>
            <div
              className={showPicker ? "selected-filter" : "filter-on-chart"}
              onClick={() => customDate()}
            >
              <FaCalendar size={20} />
            </div>
          </div>
        </div>

        {showPicker && (
          <div className="picker-box-provider">
            <div className="date-range-picker-container">
              <DateRangePicker
                ranges={[state.selection]}
                onChange={handleSelect}
                maxDate={new Date()}
              />

              <div className="recon-date-btn">
                <button
                  onClick={(e) => handleClear(e)}
                  className="clear-button"
                >
                  Clear
                </button>
                <button onClick={() => handleApply()} className="apply-button">
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
        <p className="dash-head" style={{ margin: "10px" }}>
          <span>Selected Date Ranges : </span>
          <span className="selectedOrg">
            {state.selection.startDate &&
              state.selection.endDate &&
              `${new Date(state.selection.startDate).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }
              )} - ${new Date(state.selection.endDate).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }
              )}`}
          </span>
        </p>

        {isLoading ? (
          <ShimmerThumbnail height={600} rounded />
        ) : (
          <div className="table-main-div">
            <table
              className="table-user-management"
              style={{ "min-height": "10rem" }}
            >
              <thead className="table-user-header">
                <tr>
                  <td>
                    <p className="user-table-head">S.No</p>
                  </td>
                  <td>
                    <p className="user-table-head">Provider Name</p>
                  </td>
                  <td className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Active</p>
                      <FaFilter
                        style={{ marginRight: "0.2rem", cursor: "pointer" }}
                        onMouseEnter={() => setShowActive(true)}
                        onMouseLeave={() => setShowActive(false)}
                      />
                    </div>
                    {showActive && (
                      <div
                        className="transfer-mode"
                        onMouseEnter={() => setShowActive(true)}
                        onMouseLeave={() => setShowActive(false)}
                      >
                        <p onClick={() => setActiveFilter("")}>All</p>
                        <p onClick={() => setActiveFilter("yes")}>Yes</p>
                        <p onClick={() => setActiveFilter("no")}>No</p>
                      </div>
                    )}
                  </td>
                  {(role == "super" || role == "operation") && (
                    <td className="filter-pos">
                      <div className="data-icon">
                        <p className="user-table-head-report">Org Name</p>
                        <FaFilter
                          style={{
                            marginRight: "0.2rem",
                            width: "1rem",
                            height: "1rem",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setOrgName(true)}
                          onMouseLeave={() => setOrgName(false)}
                        />
                      </div>
                      {orgName && (
                        <div
                          className="transfer-mode"
                          onMouseEnter={() => setOrgName(true)}
                          onMouseLeave={() => setOrgName(false)}
                        >
                          <p
                            onClick={() => {
                              setSelectedOrgName("All");
                              setOrgName(false);
                            }}
                          >
                            All
                          </p>
                          {orgOptions.map((org) => (
                            <p
                              key={org.id}
                              onClick={() => {
                                setSelectedOrgName(org.orgName);
                                setOrgName(false);
                              }}
                            >
                              {org.orgName}
                            </p>
                          ))}
                        </div>
                      )}
                    </td>
                  )}
                  <td className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Type</p>
                      <FaFilter
                        style={{ marginRight: "0.2rem", cursor: "pointer" }}
                        onMouseEnter={() => setShowType(!showType)}
                      />
                    </div>
                    {showType && (
                      <div
                        className="transfer-mode"
                        onMouseLeave={() => setShowType(false)}
                      >
                        <p onClick={() => setTypeFilter("")}>All</p>
                        <p onClick={() => setTypeFilter("payin")}>Payin</p>
                        <p onClick={() => setTypeFilter("payout")}>Payout</p>
                        <p onClick={() => setTypeFilter("both")}>Both</p>
                      </div>
                    )}
                  </td>
                  <td>
                    <p className="user-table-head">Payin Commission</p>
                  </td>
                  <td>
                    <p className="user-table-head">Payout Commission</p>
                  </td>
                  <td>
                    <p className="user-table-head">
                      Minimum Payin per Transaction
                    </p>
                  </td>
                  <td>
                    <p className="user-table-head">
                      Maximum Payin per Transaction
                    </p>
                  </td>
                  <td>
                    <p className="user-table-head">
                      Minimum Payout per Transaction
                    </p>
                  </td>
                  <td>
                    <p className="user-table-head">
                      Maximum Payout per Transaction
                    </p>
                  </td>
                  <td>
                    <p className="user-table-head">Total Payin</p>
                  </td>
                  <td>
                    <p className="user-table-head">Total Payout</p>
                  </td>
                  <td>
                    <p className="user-table-head">Current Payin Amount</p>
                  </td>
                  <td>
                    <p className="user-table-head">Current Payout Amount</p>
                  </td>
                  <td>
                    <p className="user-table-head">Running Wallet Balance</p>
                  </td>

                  <td>
                    <p className="user-table-head">Daily Payin Amount</p>
                  </td>
                  <td>
                    <p className="user-table-head">Start Time</p>
                  </td>
                  <td>
                    <p className="user-table-head">End Time</p>
                  </td>
                  <td>
                    <p className="user-table-head">Update</p>
                  </td>
                </tr>
              </thead>

              <tbody>
                {providerTableData
                  .filter((item) => {
                    if (!selectedOrgName || selectedOrgName === "All") {
                      return true;
                    }
                    return item.orgName === selectedOrgName;
                  })
                  .filter((item) => !typeFilter || item.type === typeFilter)
                  .filter((item) => {
                    if (!activeFilter) return true;
                    if (activeFilter === "yes") return item.isActive === true;
                    if (activeFilter === "no") return item.isActive === false;
                    return true;
                  })
                  .sort((a, b) =>
                    a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1
                  )
                  .map((item, i) => {
                    return (
                      <tr
                        className="table-user-data"
                        key={item.id}
                        style={item.isActive ? {} : { color: "#848884" }}
                      >
                        <td>
                          <p className="user-table-head">{i + 1}</p>
                        </td>
                        <td>
                          <p
                            className="user-table-name"
                            style={{ width: "10rem" }}
                            onClick={() =>
                              handleProviderClick(item.id, item.providerName)
                            }
                          >
                            {item.providerName}
                          </p>
                        </td>
                        <td>
                          <p
                            className={`user-table-head ${
                              item.isActive ? "status-yes" : "status-no"
                            }`}
                          >
                            {item.isActive ? "Yes" : "No"}
                          </p>
                        </td>

                        {(role == "super" || role == "operation") && (
                          <td>
                            <p className="user-table-head">
                              {item.orgName || "N/A"}
                            </p>
                          </td>
                        )}
                        <td>
                          <p className="user-table-head">{item.type}</p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.providerPayinComm).toFixed(3)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.providerPayoutComm).toFixed(3)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinMinPerTxn).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinMaxPerTxn).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payoutMinPerTxn).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payoutMaxPerTxn).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.totalPayinLimit).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.totalPayoutLimit).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.currentPayinAmount).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.currentPayoutAmount).toFixed(2)}
                          </p>
                        </td>

                        <td>
                          <p className="user-table-head">
                            {Number(item.runningWalletAmount).toFixed(2)}
                          </p>
                        </td>

                        <td>
                          <p className="user-table-head">
                            {Number(item.dailyPayinAmount).toFixed(2)}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {new Date(item.startTime).toLocaleTimeString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              }
                            )}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {new Date(item.endTime).toLocaleTimeString(
                              "en-GB",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: true,
                              }
                            )}
                          </p>
                        </td>
                        <td>
                          <p
                            className="user-table-head"
                            onClick={() => updateProvider(item)}
                          >
                            <CiEdit
                              style={{
                                width: "1.2rem",
                                height: "1.2rem",
                                cursor: "pointer",
                              }}
                            />
                          </p>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
        {isModalOpen && (
          <Modal
            onClose={handleModalClose}
            onSubmit={handleUpdateSubmit}
            formData={currentProvider}
            handleInputChange={handleInputChange}
          />
        )}
        {showModal &&
          (isLoading ? (
            <Spinner style />
          ) : (
            <ProviderModal
              transactionData={transactionData}
              setShowModal={setShowModal}
              startDate={state.selection.startDate.toISOString()}
              endDate={state.selection.endDate.toISOString()}
              userName={selectedProviderName}
            />
          ))}
      </div>
    </>
  );
};

export default GetProvider;
